import makeHTTPRequest from '../makeHTTPRequest';

export const getSalesAccessToken = () =>
  makeHTTPRequest({
    path: 'linkedin/sales_access_token',
  });
